import React from "react";
import {
  Box,
  Button,
  HStack,
  Icon,
  IconButton,
  SimpleGrid,
  Text,
  VStack,
  useColorMode,
} from "@chakra-ui/react";
import { BiPencil } from "react-icons/bi";

const HeroStatsRow = ({
  stats,
  preferences,
  todayAccountValue,
  today,
  featureFlag,
  format,
  formatter,
  percent,
  pnlValue,
  colorChange,
  onEditAccountValue,
  // TRADE-959
  planAdherence,
}) => {
  const { colorMode } = useColorMode();
  const cardBg = colorMode === "light" ? "white" : "gray.700";
  const labelColor = colorMode === "light" ? "gray.600" : "gray.400";
  const subColor = colorMode === "light" ? "gray.500" : "gray.300";

  const totalFees = parseFloat(stats?.total_fees ?? 0);
  const planAdherencePct = planAdherence?.followed?.win_pct;
  return (
    <SimpleGrid columns={{ base: 2, md: 6 }} spacing={3}>
      <Box bg={cardBg} rounded="lg" px={4} py={3} boxShadow="sm">
        <Text fontSize="xs" color={labelColor} mb={1}>Account Value</Text>
        {featureFlag ? (
          <>
            <HStack spacing={1}>
              <Text fontSize="lg" fontWeight="bold">
                {format(todayAccountValue, preferences.preferred_currency)}
              </Text>
              <IconButton
                colorScheme="gray"
                aria-label="update account value"
                size="xs"
                variant="ghost"
                icon={<Icon as={BiPencil} />}
                onClick={onEditAccountValue}
              />
            </HStack>
            <Text fontSize="xs" color={subColor}>{today}</Text>
          </>
        ) : (
          <VStack align="stretch" spacing={1} w="full">
            <Text fontSize="xs" color={subColor} fontStyle="italic">Not tracking</Text>
            <Button
              size="xs"
              colorScheme="blue"
              variant="outline"
              onClick={onEditAccountValue}
              w="full"
              whiteSpace="normal"
              height="auto"
              py={1}
            >
              Enable tracking
            </Button>
          </VStack>
        )}
      </Box>
      <Box bg={cardBg} rounded="lg" px={4} py={3} boxShadow="sm">
        <Text fontSize="xs" color={labelColor} mb={1}>Total PNL</Text>
        <Text
          fontSize="lg"
          fontWeight="bold"
          color={colorChange(stats.total_pnl)}
        >
          {pnlValue(formatter(preferences.preferred_currency).format(stats.total_pnl))}
        </Text>
      </Box>
      <Box bg={cardBg} rounded="lg" px={4} py={3} boxShadow="sm">
        <Text fontSize="xs" color={labelColor} mb={1}>Total Fees</Text>
        <Text fontSize="lg" fontWeight="bold" color="orange.400">
          {formatter(preferences.preferred_currency).format(totalFees)}
        </Text>
      </Box>
      <Box bg={cardBg} rounded="lg" px={4} py={3} boxShadow="sm">
        <Text fontSize="xs" color={labelColor} mb={1}>Win %</Text>
        <Text fontSize="lg" fontWeight="bold">
          {percent.format(stats.win_percent / 100)}
        </Text>
      </Box>
      <Box bg={cardBg} rounded="lg" px={4} py={3} boxShadow="sm">
        <Text fontSize="xs" color={labelColor} mb={1}># of Trades</Text>
        <Text fontSize="lg" fontWeight="bold">{stats.num_trades}</Text>
      </Box>
      <Box bg={cardBg} rounded="lg" px={4} py={3} boxShadow="sm">
        <Text fontSize="xs" color={labelColor} mb={1}>Plan Adherence</Text>
        <Text fontSize="lg" fontWeight="bold">
          {planAdherencePct != null ? `${planAdherencePct}%` : "—"}
        </Text>
        <Text fontSize="xs" color={subColor}>
          {planAdherence?.followed?.num_trades != null
            ? `n=${planAdherence.followed.num_trades}`
            : ""}
        </Text>
      </Box>
    </SimpleGrid>
  );
};

export default HeroStatsRow;
